export enum ServiceTypes {
  GeneralService = 'GENERAL_SERVICE',
  PeopleService = 'PEOPLE_SERVICE',
}
